import {styled} from '@linaria/react';
import React, {ComponentProps, FC} from 'react';
import {BlurryBackground} from '../../atoms/BlurryBackground/BlurryBackground';

export const BackgroundCard: FC<
  ComponentProps<typeof BlurryBackground> & {isActive: boolean}
> = props => {
  return (
    <li data-active={props.isActive} data-testid="backgroundCard">
      <StyledBlurryBackground {...props} />
    </li>
  );
};

const StyledBlurryBackground = styled(BlurryBackground)`
  opacity: 0;
  transition: opacity 500ms ease-in-out 250ms;

  [data-active='true'] & {
    transition-delay: 0ms;
    opacity: 1;
  }
`;
